import { Button, Dialog, DialogContent, DialogTitle, IconButton, TextField } from "@material-ui/core";
import { CloudDownload, Print, Visibility, PhoneIphone, Payment, AttachMoney, Email } from "@material-ui/icons";
import CloseIcon from '@material-ui/icons/Close';
import SelectField from "common/components/SelectField";
import { renderDate, renderMoney } from "common/services/util";
import { getStockData } from "common/store/reducers/stock";
import { getTasksData } from "common/store/reducers/tasks";
import SearchField from "invoices/components/SearchField";
import SwitchEdit from "invoices/components/SwitchEdit";
import IvaSwitch from "invoices/components/IvaSwitch";
import TableInvoiceDetail from "invoices/components/TableInvoiceDetail";
import TextFieldEdit from "invoices/components/TextFieldEdit";
import { columnsInvoiceDetail, mapPaymentMode } from "invoices/services/config";
import createPDFInvoiceUseCase from "invoices/services/createPDFInvoice";
import { calculateTotalInvoice, calculateTotalPrice } from "invoices/services/detail/calculateInvoicesInfo";
import filterItemsUseCase from "invoices/services/filterItemsUseCase";
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import findClientByTask from "tasks/services/sign/findClientByTask";
import createPDFTicketUseCase from "tickets/services/createPDFTicket";
import updateTicketDetailUseCase from "tickets/services/detail/updateTicketDetailUseCase";
import sendTicketByEmailUseCase from "tickets/services/sendTicketByEmailUseCase";
import { v4 as uuidv4 } from 'uuid';

const TicketDetailContainer = ({
    open,
    dataTicket,
    dataDetail,
    onClose,
    stockList,
    taskList,
    onChangePaymentMode
}) => {
    const initialData = items => {
        return items.map(item => {
            return { ...item, id: uuidv4(), totalPrice: calculateTotalPrice(item) }
        })
    }

    const [hover, setHover] = React.useState(false);
    const [showReviewBtn, setShowReviewBtn] = useState(false);
    const [openProtectorPrompt, setOpenProtectorPrompt] = useState(false);
    const [data, setData] = useState(initialData(dataDetail.items))
    const [dataRender, setDataRender] = useState([])
    const [client, setClient] = useState({})
    const [timeoutId, setTimeoutId] = useState(null)
    const [moneyToPay, setMoneyToPay] = useState(null)
    const [numberPhone, setNumberPhone] = useState(null)
    const [openPaymentConfirmPrompt, setOpenPaymentConfirmPrompt] = useState(false);

    const hasProtectorIn = (items = []) =>
        items.some(it => (it.description || '').toLowerCase().includes('protector de pantalla'));

    const handleAttemptClose = () => {
        if (!dataTicket?.paymentMode) {
            setOpenPaymentConfirmPrompt(true);
            return;
        }
        onClose();
    };

    useEffect(() => {
        if (dataTicket?.paymentMode) setShowReviewBtn(true);
        // Mostrar recordatorio de protector solo si aún no hay uno en el ticket
        const alreadyHasProtector =
          hasProtectorIn(dataDetail?.items) || hasProtectorIn(data);
        if (!alreadyHasProtector) {
          setOpenProtectorPrompt(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const dataRender = [...data, ...new Array(1).fill({ isEmpty: true, iva: true, units: 1 })]
        setDataRender(dataRender)

        clearTimeout(timeoutId)
        const id = setTimeout(() => updateTicketDetailUseCase(dataTicket, dataTicket.ivaPercent, { data }), 1000)
        setTimeoutId(id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (!dataTicket.dniClient) {
            return
        }

        findClientByTask(dataTicket.dniClient).then(clientData => setClient(clientData))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleInvoiceItemUpdate = async (item) => {
        if (item.isEmpty) {
            const newItem = { ...item, isEmpty: false, id: uuidv4(), totalPrice: calculateTotalPrice(item) }
            setData((prevState) => [...prevState, newItem])
            return
        }

        setData((prevState) => {
            item = { ...item, totalPrice: calculateTotalPrice(item) }
            const dataUpdated = prevState
                .map(itemData => itemData.id === item.id ? item : itemData)

            return dataUpdated
        })
    }

    const handleInvoiceItemDelete = async (item) => {
        const newData = data.filter(i => i.id !== item.id)
        setDataRender([])
        setData(newData)
    }

    const handleAddProtectorItem = () => {
        const newItem = {
            id: uuidv4(),
            isEmpty: false,
            reference: '',
            description: 'PROTECTOR DE PANTALLA',
            units: 1,
            unitPrice: 19.90,
            iva: true
        }

        setData(prev =>
            [...prev, { ...newItem, totalPrice: calculateTotalPrice(newItem) }]
        )

        setOpenProtectorPrompt(false)
    }

    const handleInvoicePrint = (operation) => {
        createPDFTicketUseCase({
            ticketData: dataTicket,
            initialTicketDetailData: { data },
            operation,
            numberPhone
        })
    }

    const handleSendTicketByEmail = async () => {
        try {
            await sendTicketByEmailUseCase(dataTicket);
            alert("Ticket enviado por email ✅");
        } catch (err) {
            console.error("❌ Error al enviar ticket por email", err);
            alert(err.message || "Error al enviar el ticket por email");
        }
    };

    const textField = (item, field, isNumeric, isMoney) => {
        const handle = value => {
            item[field] = value
            handleInvoiceItemUpdate(item)
        }

        return (
            <TextFieldEdit
                handleChange={handle}
                initialValue={item[field]}
                isNumeric={isNumeric}
                isMoney={isMoney}
            />
        )
    }

    const switchField = (item, field) => {
        const handle = value => {
            item[field] = value
            handleInvoiceItemUpdate(item)
        }

        return (
            <IvaSwitch
                checked={Boolean(item[field])}
                onChange={(event) => handle(event.target.checked)}
            />
        )
    }

    const searchField = item => {
        const stockToSearch = getStockData(stockList)
        const taskToSearch = getTasksData(taskList).map(task => {
            return { ...task, pvp: task.budget }
        })
        const itemsToSearch = [...stockToSearch, ...taskToSearch].sort((s1, s2) => s2.reference - s1.reference)

        const handle = ({ reference, description, pvp }) => {
            item.reference = reference

            if (description) {
                item.description = description
            }

            if (!item.units) {
                item.units = 1
            }

            if (pvp) {
                item.unitPrice = pvp
            }

            handleInvoiceItemUpdate(item)
        }

        return (
            <SearchField
                textInitial={item.reference}
                onTextRender={item => item.reference}
                items={itemsToSearch}
                onFilterItems={(itemList, textFilter) =>
                    filterItemsUseCase({
                        itemList,
                        textFilter,
                        fieldsFilter: ["reference", "description"]
                    })
                }
                onSelectItem={handle}
                onRenderItem={({ reference, description }) => `${reference}-${description}`}
            />
        )
    }

    const handleChangePaymentMode = async (ticket, paymentMode, moneyToPay) => {
        dataTicket = { ...dataTicket, paymentMode, moneyToPay }
        const newTicket = await updateTicketDetailUseCase(dataTicket, dataTicket.ivaPercent, { data }, paymentMode, moneyToPay)
        onChangePaymentMode(newTicket)
        setShowReviewBtn(true)
    }

    const columns = columnsInvoiceDetail({ textField, switchField, searchField })

    const infoTicket = calculateTotalInvoice(data, dataTicket.ivaPercent)

    console.log("Data ticket" + dataTicket.paymentMode)

    return (
        <Dialog
            fullScreen={window.innerHeight < 900}
            fullWidth={true}
            maxWidth={'lg'}
            open={open}
        >
            <IconButton onClick={handleAttemptClose} style={{ position: 'absolute', right: '5px', top: '5px' }}>
                <CloseIcon />
            </IconButton>
            <DialogTitle>
                <div style={{ maxHeight: '80px', textWrap: 'nowrap', fontSize: window.innerWidth > 600 ? '20px' : '4vw' }}>
                    <div>Factura: {dataTicket.numTicket} - {renderDate(dataTicket.ticketDate)} - {dataTicket.nameClient}</div>
                    {dataTicket.dniClient && <div> {dataTicket.dniClient} - {client.mail}</div>}
                    {dataTicket.dniClient && <div>C/{client.street},{client.postcode},{client.locality}({client.community})</div>}
                </div>
            </DialogTitle>
            <DialogContent style={{ display: 'flex' }}>
                <TableInvoiceDetail
                    columns={columns}
                    data={dataRender}
                    onInvoiceItemDelete={handleInvoiceItemDelete}
                    margins={[20, 100]}
                />
                <div style={{
                    display: 'flex',
                    width: '30%',
                    minWidth: '300px',
                    flexDirection: 'column',
                    margin: '20px',
                    marginTop: '5px',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div style={{ width: '200px', fontSize: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>Base:</span>
                            <span>{renderMoney(infoTicket.base)}</span>
                        </div>
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
                            <span>IVA:</span>
                            <span>{renderMoney(infoTicket.ivaPrice)}</span>
                        </div>
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', fontWeight: 'bold', fontSize: '25px' }}>
                            <span>TOTAL:</span>
                            <span>{renderMoney(infoTicket.total)}</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '200px' }}>
                        <div>
                            <div style={{ fontSize: '25px', fontWeight: 'bold', marginBottom: "8px" }}>Pago del cliente</div>
                            {!dataTicket.paymentMode &&
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div>
                                        <TextField type="number"
                                            variant="outlined"
                                            placeholder="Cantidad en efectivo"
                                            value={moneyToPay}
                                            style={{ marginBottom: "15px", width: '100%' }}
                                            onChange={evt => setMoneyToPay(evt.target.value)}
                                            error={moneyToPay && moneyToPay < infoTicket.total}
                                            helperText={(moneyToPay && moneyToPay < infoTicket.total) ? "El valor debe ser mayor al total" : " "}
                                        />
                                    </div>
                                    <div style={{ display: "flex", justifyContent: 'space-between', marginTop: "5px", gap: "15px" }}>
                                        <Button variant="contained"
                                            color="primary"
                                            style={{ flex: 1, height: '80px', width: '100%' }}
                                            disabled={!moneyToPay || moneyToPay < infoTicket.total}
                                            onClick={() => handleChangePaymentMode(dataTicket, 2, moneyToPay)}>
                                            <AttachMoney /> Efectivo
                                        </Button>
                                        <Button variant="contained"
                                            color="primary"
                                            style={{ flex: 1, height: '80px', width: '100%' }}
                                            onClick={() => handleChangePaymentMode(dataTicket, 1, 0)}>
                                            <Payment /> Tarjeta
                                        </Button>
                                    </div>
                                </div>
                            }
                            {dataTicket.paymentMode === 1 && <div style={{ fontSize: "20px", width: '200px' }}>Pagado con tarjeta</div>}
                            {dataTicket.paymentMode === 2 &&
                                <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '200px', fontSize: "20px" }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Efectivo:</span>
                                        <span>{renderMoney(dataTicket.moneyToPay)}</span>
                                    </div>
                                    <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: "22px", fontWeight: 'bold' }}>Cambio:</span>
                                        <span style={{ fontSize: "22px", fontWeight: 'bold' }}>{renderMoney(dataTicket.moneyToPay - infoTicket.total)}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                        <div style={{ width: '100%' }}>
                            <TextField 
                                variant="outlined" 
                                style={{ width: '100%' }} 
                                label="Numero a enviar"
                                value={numberPhone}
                                onChange={evt => setNumberPhone(evt.target.value)}
                            />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {/*
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ width: '90px', height: '50px' }}
                                onClick={() => handleInvoicePrint("view")}
                            >
                                <Visibility />
                            </Button>
                            */}
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ width: '90px', height: '50px' }}
                                onClick={() => handleInvoicePrint("print")}
                            >
                                <Print />
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ width: '90px', height: '50px' }}
                                onClick={() => handleInvoicePrint("upload")}
                            >
                                <PhoneIphone />
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ width: '90px', height: '50px' }}
                                onClick={handleSendTicketByEmail}
                            >
                                <Email />
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ width: '90px', height: '50px' }}
                                onClick={() => handleInvoicePrint("save")}
                            >
                                <CloudDownload />
                            </Button>
                            {showReviewBtn && (
                                <Button
                                    variant="contained"
                                    disableElevation
                                    onMouseEnter={() => setHover(true)}
                                    onMouseLeave={() => setHover(false)}
                                    style={{
                                    width: 190,
                                    height: 50,
                                    fontWeight: 600,
                                    backgroundColor: hover ? '#e6005c' : '#ff0066',
                                    color: '#ffffff',
                                    borderRadius: 6,
                                    boxShadow: '0 8px 16px rgba(255, 0, 102, 0.35)',
                                    textTransform: 'none',
                                    padding: '10px 16px'
                                    }}
                                    onClick={() =>
                                    createPDFTicketUseCase({
                                        ticketData: dataTicket,
                                        initialTicketDetailData: { data },
                                        operation: "upload",
                                        numberPhone,
                                        extraText: [
                                        "Tu opinión es muy importante para nosotros, déjanos 5 estrellas en Google ⭐⭐⭐⭐⭐ a través del siguiente link:",
                                        "http://search.google.com/local/writereview?placeid=ChIJl3cv_CuNNg0RIM94oBXDvxI",
                                        "Muchas gracias por confiar en IFENO"
                                        ].join("\n\n")
                                    })
                                    }
                                >
                                    <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    lineHeight: 1
                                    }}>
                                    <span style={{ fontSize: 15, letterSpacing: 0.3 }}>Pedir reseña</span>
                                    <span style={{ fontSize: 14, marginTop: 4 }}>⭐⭐⭐⭐⭐</span>
                                    </div>
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </DialogContent>
            <Dialog open={openPaymentConfirmPrompt} maxWidth="xs" fullWidth>
                <DialogTitle style={{ textAlign: 'center' }}>
                    No has seleccionado método de pago, ¿estás seguro de cerrar el ticket?
                </DialogTitle>
                <DialogContent style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => { setOpenPaymentConfirmPrompt(false); onClose(); }}
                    >
                        Cerrar sin pagar
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenPaymentConfirmPrompt(false)}
                    >
                        Elegir pago
                    </Button>
                </DialogContent>
            </Dialog>
            <Dialog
            open={openProtectorPrompt}
            onClose={() => setOpenProtectorPrompt(false)}
            maxWidth="xs"
            fullWidth
            >
            <DialogTitle style={{ textAlign: 'center' }}>
                OFRECER PROTECTOR DE PANTALLA
            </DialogTitle>
            <DialogContent style={{ display: 'flex',textAlign: 'center', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontSize: 14, opacity: 0.85 }}>
                Recuerda preguntar al cliente si quiere poner protector de pantalla.
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 4 }}>
                <Button variant="contained" color="primary" onClick={handleAddProtectorItem}>
                    Añadir ahora
                </Button>
                <Button variant="outlined" onClick={() => setOpenProtectorPrompt(false)}>
                    Cancelar
                </Button>
                </div>
            </DialogContent>
            </Dialog>
        </Dialog>
    )
}

const mapStateToProps = state => ({
    stockList: state.stock.data,
    taskList: state.tasks.data
})

export default connect(mapStateToProps, null)(TicketDetailContainer)